export type AppTheme = 'light' | 'dark';
export type AppColorTheme = 'blue' | 'red';

export const applyTheme = (theme: AppTheme, colorTheme: AppColorTheme = 'blue') => {
  const root = document.documentElement;

  root.classList.remove('light', 'dark');
  root.classList.add(theme);
  root.setAttribute('data-color-theme', colorTheme);
};
